angular.module('quattro.bmbo.account.create', [
    'quattro.core.hpls_api_1',
    'quattro.core.alert.service',
    'quattro.core.user.service',
    'quattro.core.password.service',
    'quattro.bmbo.config',
    'quattro.bmbo.account.model',
])
    .controller('CreateAccountController', function ($location, $window, passwordService, alertService, userService, Account) {

        var d = new Date();
        var adminMemoDefault = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + userService.get('userName');

        var model = new Account({
            admin_memo: adminMemoDefault
        }, 'create');
        this.data = model.data;


        this.generatePassword = function () {
            passwordService
                .createValid()
                .then(function (result) {
                    this.data.password = result;
                });
        };

        this.cancel = function () {
            $window.history.back();
        };

        this.save = function () {

            // if (!viewHelper.formIsValid()) {
            //     return;
            // }

            model.create()
                .then(function () {
                    alertService.add('success', 'Account wurde angelegt.');
                    $location.path('/account=' + model.data.account);
                }, function () {
                    alertService.add('error', 'Account konnte nicht angelegt werden.');
                });

        };
    });
